export default "__VITE_ASSET__kKq4F49l__"